import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useState } from 'react'
import Agree from './Agree'
import BarLoader from 'react-spinners/BarLoader'
import ShareBtn from '../ShareBtn'

function Layout({ setCompletionMessage }) {
  const [ac, setAc] = useState(null)
  const [tk, setTk] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [showShareBtn, setShowShareBtn] = useState(true)

  // let { pid } = useParams()
  // pid = 'P' + pid.split('p')[1]
  // 特殊設定
  // const { pathname } = useLocation()
  const pid = 'P250603155903216'
  const { uid } = useParams()
  // console.log('uid', uid)

  // pid = 'P' + pid.split('/p')[1]
  // const pid = 'P231206105643'
  // 隨機一份問卷
  // const pidObj = {
  //   0: 'P230919184319',
  //   1: 'P230815121716',
  //   2: 'P230815121714',
  // }

  // const [randomPid, setrandomPid] = useState('')
  // useEffect(() => {
  //   const ord = Math.floor(Math.random() * 3)
  //   setrandomPid(pidObj[ord])
  // }, [])
  // console.log('randomPid', randomPid)

  // BarLoader
  const actualInnerWidth = document.body.clientWidth - 20

  return (
    <>
      <BarLoader
        cssOverride={{ overflow: 'hidden', position: 'fixed', zIndex: '1021' }}
        color="#19b394"
        width={actualInnerWidth}
        loading={isLoading}
      />

      <Agree
        setIsLoading={setIsLoading}
        pid={pid}
        setAc={setAc}
        setTk={setTk}
        ac={ac}
        tk={tk}
        setShowShareBtn={setShowShareBtn}
        setCompletionMessage={setCompletionMessage}
        userId={uid}
      />
      {/* <ShareBtn showShareBtn={showShareBtn} shareUrl={shareUrl} /> */}
    </>
  )
}

export default Layout
